/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const FormWithFieldConfigsContext = React.createContext({});

const FormWithFieldConfigsProvider = ({
  children,
  initialValues,
  layout,
  groupFields,
  disabled,
  fields = [],
  renderMiddlewares = [],
  middlewares = [],
  FIELD_PROVIDER,
}) => {
  const applyMiddlewares = React.useCallback(
    (field) => {
      return (...args) =>
        middlewares.reduce((current, middleware) => {
          return middleware(current, ...args);
        }, field);
    },
    [middlewares]
  );

  const applyRenderMiddlewares = React.useCallback(
    (field) => {
      return (...args) =>
        renderMiddlewares.reduce((current, middleware) => {
          return middleware(current, ...args);
        }, field);
    },
    [renderMiddlewares]
  );

  const refineField = React.useCallback((field) => {
    return (...args) => {
      const refinedField = applyMiddlewares(field)(...args);
      return {
        ...refinedField,
        render: applyRenderMiddlewares(refinedField),
      };
    };
  });

  const patchedFields = React.useMemo(() => {
    return fields.map((field) => {
      return refineField(field);
    });
  }, [refineField, fields]);

  return (
    <FormWithFieldConfigsContext.Provider
      value={{
        patchedFields,
        fields,
        middlewares,
        renderMiddlewares,
        initialValues,
        FIELD_PROVIDER,
        layout,
        disabled,
        groupFields,
      }}>
      {children}
    </FormWithFieldConfigsContext.Provider>
  );
};
FormWithFieldConfigsProvider.propTypes = {
  children: PropTypes.node,
  initialValues: PropTypes.object,
  fields: PropTypes.array,
  renderMiddlewares: PropTypes.array,
  middlewares: PropTypes.array,
  FIELD_PROVIDER: PropTypes.func,
  groupFields: PropTypes.func,
  layout: PropTypes.oneOf(['vertical', 'horizontal']),
  disabled: PropTypes.bool,
};

export { FormWithFieldConfigsContext, FormWithFieldConfigsProvider };
